import React, { useEffect, useState } from 'react';
import { Script } from 'gatsby';
import { useTrustArc } from '../../context/trust-arc.context';

const LOOX_SCRIPT_SRC = 'https://loox.io/widget/loox.js?shop=piaggiofastforward.myshopify.com';

const LooxWidgetScript = () => {
  const { trustArcConsent } = useTrustArc();
  const [shouldLoad, setShouldLoad] = useState(false);

  useEffect(() => {
    setShouldLoad(trustArcConsent.includes(3));
  }, [trustArcConsent]);

  if (!shouldLoad) {
    return null;
  }

  return <Script strategy="idle" src={LOOX_SCRIPT_SRC} />;
};

export default LooxWidgetScript;
